import type { ManagedMcpIntegration } from '../../../../services/mcpService';
import type { McpProviderUiModule } from './types';

const isMicrosoft365CalendarIntegration = (integration: ManagedMcpIntegration) => {
  const code = (integration.code || '').toLowerCase();
  const name = (integration.name || '').toLowerCase();
  const description = (integration.description || '').toLowerCase();
  return (
    code.includes('microsoft-365-calendar') ||
    code.includes('microsoft_365_calendar') ||
    code.includes('ms365-calendar') ||
    code.includes('ms365') ||
    name.includes('microsoft 365 calendar') ||
    name.includes('ms365 calendar') ||
    description.includes('microsoft 365 calendar')
  );
};

export const microsoft365CalendarProviderUiModule: McpProviderUiModule = {
  providerCode: 'microsoft-365-calendar',
  matches: (integration: ManagedMcpIntegration) => isMicrosoft365CalendarIntegration(integration),
  getUiConfig: () => ({
    providerCode: 'microsoft-365-calendar',
    displayName: 'Microsoft 365 Calendar',
    supportsDynamicClientRegistration: false,
    requireClientId: false,
    requireClientSecret: false,
    showEndpointOverride: false,
    useAdminConsent: true,
    adminConsentButtonLabel: 'Authorize for my Organization',
    extraAuthFields: [],
  }),
};
